<template>
  <div>
    <el-upload
      :action="action"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :multiple="multiple"
      :drag="drag"
      :limit="limit"
      :disabled="disabled"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :on-success="uploadSuccess"
      class="upload-file"
    >
      <el-button size="small" type="primary" :disabled="disabled"
        >点击上传</el-button
      >
      <div slot="tip" class="el-upload__tip" v-text="tip"></div>
    </el-upload>
    <PreviewByFileId
      v-if="fileId"
      :value="previewModal"
      :fileId="fileId"
      @change="e => (previewModal = e)"
    />
  </div>
</template>

<script>
import FormConfig from "../formConfig"; // 表单配置
import PreviewByFileId from "./previewByFileId"; // 文件预览组件
// 文件
export default {
  name: "UploadFile",
  components: {
    PreviewByFileId
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: ""
    }
  },
  data() {
    return {
      dataModel: this.value,
      size: FormConfig.config.size,
      action: workFlowConfig.configApi.fileUploadApi,
      fileList: [],
      previewModal: false, // 预览窗口
      fileId: "",
      fileUrl: "",
      fileName: "",
      showFrame: false
    };
  },
  computed: {
    multiple() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.multiple;
      return status;
    },
    drag() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.drag;
      return status;
    },
    limit() {
      let element = this.$parent.element || this.$parent.widget;
      let status = element.options.limit || 0;
      return status;
    },
    tip() {
      let element = this.$parent.element || this.$parent.widget;
      let status = element.options.tip || "";
      return status;
    },
    disabled() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.disabled;
      return status;
    }
  },
  watch: {
    value(val) {
      this.init();
    },
    dataModel(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.dataModel = this.value;
      if (typeof this.value === "object") {
        let files = _.cloneDeep(this.value);
        this.initArray(files);
        return;
      }
      if (this.value.includes("[{")) {
        let str = this.value
          .replace(/{/g, '{"')
          .replace(/}/g, '"}')
          .replace(/, /g, '", "')
          .replace(/}"/g, "}")
          .replace(/"{/g, "{")
          .replace(/=/g, '":"');
        let files = JSON.parse(str);
        this.initArray(files);
        return;
      }
    },
    // 初始化数据
    initArray(array) {
      array.map(item => {
        item.url = item.fileUrl;
        item.response = {
          data: item
        };
      });
      this.fileList = array;
    },
    // 预览
    handlePreview(file) {
      let datas = file.response.data;
      this.fileId = datas.id;
      this.previewModal = true;
    },
    // 上传限制
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 确认删除
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 删除数据
    handleRemove(file, fileList) {
      this.changeData(fileList);
    },
    // 数据改变
    changeData(array) {
      let list = [];
      array.map(e => {
        let data = e.response ? e.response.data : {};
        list.push({
          name: e.name,
          id: data.id,
          fileUrl: data.fileUrl
        });
      });
      this.$emit("input", list);
    },
    // 上传成功
    uploadSuccess(res, file, fileList) {
      this.changeData(fileList);
    }
  }
};
</script>
<style lang="less" scoped>
.upload-file {
  /deep/.el-upload {
    text-align: left;
  }
}
</style>
